import type { StringTable } from '../index.ts';

/**
 * Words used all over the app (namespace "common"). EN and AF must have
 * identical keys and placeholders (test/i18n.test.ts).
 */
export const COMMON: StringTable = {
  en: {
    back: 'Back',
    cancel: 'Cancel',
    close: 'Close',
    done: 'Done',
    next: 'Next',
    save: 'Save',
    tryAgain: 'Try again',
    loading: 'Loading…',
    gradeN: 'Grade {grade}',
    levelN: 'Level {level}',
    // Ads (the label is drawn by the app on every banner, as the ad policy requires)
    adLabel: 'Ad',
    adAria: 'Advertisement',
    adSampleTitle: 'Sample ad (prototype)',
    adSampleText: 'No real ads are shown in this test version.',
  },
  af: {
    back: 'Terug',
    cancel: 'Kanselleer',
    close: 'Maak toe',
    done: 'Klaar',
    next: 'Volgende',
    save: 'Stoor',
    tryAgain: 'Probeer weer',
    loading: 'Laai tans…',
    gradeN: 'Graad {grade}',
    levelN: 'Vlak {level}',
    adLabel: 'Advertensie',
    adAria: 'Advertensie',
    adSampleTitle: 'Voorbeeldadvertensie (prototipe)',
    adSampleText: 'Hierdie toetsweergawe wys geen regte advertensies nie.',
  },
};
